export const PAYMENT_GOODS_ANNUAL_FEE = '연회비';
export const PAYMENT_GOODS_CONFERENCE_FEE = '등록비';
export const PAYMENT_GOODS_PUBLICATION_FEE = '게재료';
export const PAYMENT_ANNUAL_FEE_YEAR_SUFFIX = '년도';

export const PAYMENT_METHOD_CARD = 'card';
export const PAYMENT_METHOD_ACCOUNT = 'account';

export const PAYMENT_MEMBER_LIFETIME = '종신회원';
export const PAYMENT_MEMBER_BOARD = '이사회원';
export const PAYMENT_MEMBER_REGULAR = '정회원';
export const PAYMENT_MEMBER_STUDENT = '학생회원';

export const PAYMENT_MEMBER_TYPES = [PAYMENT_MEMBER_LIFETIME, PAYMENT_MEMBER_BOARD, PAYMENT_MEMBER_REGULAR, PAYMENT_MEMBER_STUDENT] as const;

export const PAYMENT_CONFERENCE_POSITION_PROFESSOR = '교수';
export const PAYMENT_CONFERENCE_POSITION_GRADUATE = '대학원생';
export const PAYMENT_CONFERENCE_POSITION_UNDERGRADUATE = '학부생';

export const PAYMENT_PUBLICATION_TYPE_BASIC = '기본';
export const PAYMENT_PUBLICATION_TYPE_EXPRESS = '속보';

export type GoodsName = typeof PAYMENT_GOODS_ANNUAL_FEE | typeof PAYMENT_GOODS_CONFERENCE_FEE | typeof PAYMENT_GOODS_PUBLICATION_FEE;
